import { render, staticRenderFns } from "./Vaillant.vue?vue&type=template&id=6a84e182&"
import script from "./Vaillant.vue?vue&type=script&lang=js&"
export * from "./Vaillant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports